import { IRestaurant } from '@rbi-ctg/store';
import useInterval from 'hooks/use-interval';
import { logger } from 'utils/logger';
import { addSecondsToISOString } from 'utils/time-utils';

import { useStoreContext } from '..';
import { clearStoreLocalTime, getStoreLocalTime, setStoreLocalTime } from '../utils';

const REFRESH_INTERVAL = 2_000; // 2 seconds

const handleStoreLocalTimeUpdate = (store: IRestaurant) => {
  const storeLocalTime = getStoreLocalTime();
  if (!store.localTime || !store.timezone) {
    logger.warn('no store local time or timezone set for the store');
    return;
  }
  if (!storeLocalTime) {
    setStoreLocalTime(store.localTime);
    return;
  }

  // Use the value from the local storage if it is greater than the value from the store context
  const newLocalTime = addSecondsToISOString(
    storeLocalTime < store.localTime ? store.localTime : storeLocalTime,
    REFRESH_INTERVAL / 1000,
    store.timezone
  );

  setStoreLocalTime(newLocalTime);
};

export const StoreTimer = () => {
  const { store, noStoreSelected } = useStoreContext();
  useInterval(() => {
    if (noStoreSelected) {
      clearStoreLocalTime();
    } else {
      handleStoreLocalTimeUpdate(store);
      // TODO: use more handlers here as needed like
      // handleStoreClose(store);
      // handleServiceModeClose(store);
      // handleDayPartClose(store);
    }
  }, REFRESH_INTERVAL);

  return null;
};
